<Block class="search-filters" 
    id="search-sidebar"
    bind:clientHeight={sidebarHeight}
    >
    <BlockTitle style="color: white; font-size: 20px; margin-top:32px;">SEARCH</BlockTitle>
    <Segmented tag="p" style="position:absolute; top:20px; right: 15px; width: 160px;">
        <Button class="button"
            style="border-radius:20px 0 0 20px; border-right: 1px solid #51a3c1; color: rgb(81 145 206); font-size: 10px; line-height: 20px; height: 20px;"
            active={!isMetric} 
            on:click={()=> handleChangeUnit()}>English</Button>
        <Button class="button"
            style="border-radius: 0 20px 20px 0; border-left: 1px solid #51a3c1; color: rgb(81 145 206); font-size: 10px; line-height: 20px; height: 20px;"
            active={isMetric} 
            on:click={()=> handleChangeUnit()}>Metric</Button>
    </Segmented>
    <Row tag="p">
        <Col tag="span">
          <input bind:value={inputKeywords} 
                  on:keyup={() => setTimeout(handleInput('keywords'), 400)} 
                  on:change={()=> setTimeout(handleInput('keywords'), 400)}
                  on:inputEmpty={() => console.log('empty')}
                  type="String" 
                  placeholder="Keywords"
                  style="background-color: white; padding: 8px 10px;
                  box-shadow:0.5px 1px 1px 1px #cecece; width: 100%;
                  color: rgb(81 145 206); text-transform: uppercase;">
        </Col>
    </Row>
    <Row tag="p">
        <BlockHeader style="color: white; font-size: 16px;">Age</BlockHeader>
      <Col tag="span">
        <input bind:value={inputAge} 
                on:keyup={() => handleInput('age')} 
                on:change={()=> handleInput('age')}
                on:inputEmpty={() => {inputAge= null; console.log('empty')}}
                type="number" 
                placeholder="Age"
                min="-1"
                max="100"
                style="background-color: white; padding: 8px 10px;
                  box-shadow:0.5px 1px 1px 1px #cecece; width: 100%;
                  color: rgb(81 145 206); text-transform: uppercase;">
      </Col>
    </Row>
    <Row tag="p">
        <BlockHeader style="color: white; font-size: 16px;">Weight</BlockHeader>
        <Col tag="span">
            {#if isMetric == false}
                <input bind:value={inputWeight} 
                        on:keyup={() => handleInput('weight')} 
                        on:change={()=> handleInput('weight')}
                        on:inputEmpty={() => console.log('empty')}
                        type="number" 
                        min="0"
                        placeholder="Weight(lb)"
                        style="background-color: white; padding: 8px 10px;
                    box-shadow:0.5px 1px 1px 1px #cecece; width: 100%;
                    color: rgb(81 145 206); text-transform: uppercase;">
            {/if}
            {#if isMetric == true}
                <input bind:value={inputWeightMetric} 
                    on:keyup={() => handleInput('weightMetric')} 
                    on:change={()=> handleInput('weightMetric')}
                    on:inputEmpty={() => console.log('empty')}
                    type="number" 
                    min="0"
                    placeholder="Weight(kg)"
                    style="background-color: white; padding: 8px 10px;
                    box-shadow:0.5px 1px 1px 1px #cecece; width: 100%;
                    color: rgb(81 145 206); text-transform: uppercase;">
            {/if}
          </Col>
      </Row>
    <Row tag="p">
        <BlockHeader style="color: white; font-size: 16px;">Height</BlockHeader>
        <Col tag="span">
            {#if isMetric == false}
                <input bind:value={inputHeightFt} 
                    on:keyup={() => handleInput('height')} 
                    on:change={()=> handleInput('height')}
                    on:inputEmpty={() => console.log('empty')}
                    type="number" 
                    min="0"
                    placeholder="Ft"
                    style="background-color: white; padding: 8px 10px; color: rgb(81 145 206); text-transform: uppercase;
                    box-shadow:0.5px 1px 1px 1px #cecece; width: 49.5%; float: left; margin-right: 1%;">
                <input bind:value={inputHeightIn} 
                    on:keyup={() => handleInput('height')} 
                    on:change={()=> handleInput('height')}
                    on:inputEmpty={() => console.log('empty')}
                    type="number"
                    min="0" 
                    placeholder="In"
                    style="background-color: white; padding: 8px 10px; color: rgb(81 145 206); text-transform: uppercase;
                    box-shadow:0.5px 1px 1px 1px #cecece; width: 49.5%; float: left;">
            {/if}
            {#if isMetric == true}
                <input bind:value={inputHeightCm} 
                    on:keyup={() => handleInput('heightMetric')} 
                    on:change={()=> handleInput('heightMetric')}
                    on:inputEmpty={() => console.log('empty')}
                    type="number"
                    min="0" 
                    placeholder="Height(cm)"
                    style="background-color: white; padding: 8px 10px; color: rgb(81 145 206); text-transform: uppercase;
                    box-shadow:0.5px 1px 1px 1px #cecece; width: 100%; float: left;">
            {/if}
        </Col>
    </Row>

    {#each filterKeyFieldArr as key, i}
        <BlockHeader style="color: white; font-size: 16px;">{filterFieldObj[key].displayName} 
            {#if filterFieldObj[key].id == 'sex'}
            <Icon size="0px" f7="info_circle_fill" tooltip="" />
            {/if}
        </BlockHeader>
        <Segmented tag="p">
            {#each filterFieldObj[key].options as option, i}
                <Button class="button"
                    style={i ? "border-radius: 0 15px 15px 0; border-left: 1px solid #51a3c1; color: rgb(81 145 206);" 
                                : "border-radius:15px 0 0 15px; border-right: 1px solid #51a3c1; color: rgb(81 145 206);"}
                    disabled={key === 'pregnant' && !isFemale}
                    active={option.isActive} 
                    on:click={handleFilterBtnClick(key, option.value, option.isActive)}>{option.display}</Button>
            {/each}
        </Segmented>
    {/each}

    <Row tag="p" style={isMobile ? 
        "margin-buttom: 0px !important;"
        : "margin-bottom: 10px !important;"
    }>
      <Col tag="span">
        <Button raised on:click={handleReset} 
                style="border-radius: 15px; background-color: #003d79; color: #a1caf1;">Reset</Button>      
      </Col>
    </Row>

     <!-- <Row>
        <Col tag="span">
            <div style="color:white;font-size:10.5px;line-height:14px;">Recommendations updated {sLastUpdatedText}</div>
            <div style="color:white;font-size:10.5px;line-height:14px;margin-bottom:10px;">You have the latest recommendations</div>
            <Button raised on:click={refreshapi} fill small
                  style="border-radius: 5px; background-color: #c8f3f0; color: #003d79; margin-bottom: 15px;">Update Recommendations</Button>
        </Col>
        <Col tag="span">
          <Button raised on:click={handleSearch} 
                  style="border-radius: 15px; background-color: #003d79; color: #a1caf1; margin-bottom: 15px;">Search</Button>
        </Col>
    </Row> -->
    <Row>
        <div style="margin-bottom:25px; color: white;">
            <AccordionItem >
                <AccordionToggle style="margin:2px 0 5px 0;">+ Save This Search</AccordionToggle>
                <AccordionContent>
                    <div style="color:white;font-size:10.5px;line-height:14px; margin-bottom:10px;">Saved search filters are stored on the browser rather than on the server, so clearing browsing data or history will result in the removal of the saved filters.</div>
                    <input bind:value={inputSearchName} 
                    on:keyup={() => setTimeout(handleInput('keywords'), 400)} 
                    on:change={()=> setTimeout(handleInput('keywords'), 400)}
                    on:inputEmpty={() => console.log('empty')}
                    type="String" 
                    placeholder="Search Filter Name"
                    style="background-color: white; padding: 8px 10px;
                    box-shadow:0.5px 1px 1px 1px #cecece; width: 100%;
                    color: rgb(81 145 206); text-transform: uppercase;">
                <Button raised on:click={handleSaveSearch} fill small
                    style="border-radius: 5px; background-color: #c8f3f0; color: #003d79; margin-bottom: 15px;">Save</Button>
                </AccordionContent>
            </AccordionItem>
            <AccordionItem >
                <AccordionToggle style="margin:2px 0 5px 0;">+ Update Recommendations</AccordionToggle>
                <AccordionContent>
                    <div style="color:white;font-size:10.5px;line-height:14px;">Recommendations updated {sLastUpdatedText}</div>
                    <div style="color:white;font-size:10.5px;line-height:14px;margin-bottom:10px;">You have the latest recommendations</div>
                    <Button raised on:click={refreshapi} fill small
                        style="border-radius: 5px; background-color: #c8f3f0; color: #003d79; margin-bottom: 15px;">Update Recommendations</Button>
                </AccordionContent>
            </AccordionItem>
        </div>
    </Row>
</Block>
<script>
    import {
        Block,
        BlockHeader,
        BlockTitle,
        Segmented,
        Row,
        Col,
        Input,
        Button,
        Icon,
        AccordionToggle,
        AccordionItem,
        AccordionContent
    } from 'framework7-svelte';
    import { searchData, query, oFilterStore, bIsFilterStore, bIsMobileStore, apiurl, lastUpdated, arrSavedFilterKeys, fIsMetric, bIsRecReset } from '../stores.js';
    import { FILTERDEFAULT, PRIMARY_COLOR } from '../constants.js';
    import { fConvertToInches, fConvertInchesToCM, fConvertCMToInches, fConvertToFtIn, fCalculateBMI, fResetFilter, fConvertKGToLB, fConvertLBToKG } from '../utils.js';
    import { onMount, onDestroy } from 'svelte';
    import { groupBy } from '../utils.js';

    $:filterFieldObj;
    $:browserWidth = window.innerWidth;
    $:isMobile;
    $:isCollapseMobile;
    $:reportWindowSize();
    $:fHeight();
    $:fResetChange($bIsRecReset);

    let sQuery = '';
    let inputKeywords="";
    let inputSearchName="";
    let searchedKeywords='';
    let inputAge;
    let inputWeight;
    let inputWeightMetric;
    let inputHeightFt;
    let inputHeightIn;
    let inputHeightCm;
    let filterKeyFieldArr = ['sex', 'pregnant', 'tobacco', 'sexuallyActive'];
    let filterFieldObj = {};
    let isFemale = false;
    let isCollapseMobile = true;
    let isMetric = false;
    let browserWidth;
    let isMobile = false;
    let sidebarHeight = 820;
    let apiUrl;
    let data;
    let sLastUpdated, sLastUpdatedText;
    let popupOpened = false;
    let sheetOpened = false;

    onMount(async () => {
        isMetric = fIsMetric();
    });

    function fHeight() {
        sidebarHeight = window.innerHeight - window.innerHeight/5;
    }
    window.addEventListener("resize", fHeight);

    const unsubscribeAPIURL = apiurl.subscribe(value => {
        isMetric - false;
        if (!value) {
        fetch("config.json") 
        .then(response => response.json()) 
        .then(parsed => {
            apiUrl = parsed.API_URL;
            })
            .catch(error => {
            console.log('Error! ', error);
            });
        } else {
        apiUrl = value; 
        }
        });
    onDestroy(unsubscribeAPIURL);

    const unsubscribeLastUpdated = lastUpdated.subscribe(value => {
        if (!value) { return; }
        sLastUpdated = value.lastUpdated;
        sLastUpdatedText = value.lastUpdatedText;
    });
    onDestroy(unsubscribeLastUpdated);

    // Get Data
    async function getSearchData() {
        if (!apiUrl) { 
        fetch("config.json") 
        .then(response => response.json()) 
        .then(parsed => {
            apiUrl = parsed.API_URL;
            if (apiUrl) {
            apiurl.set(apiUrl);
            }
        })
        .catch(error => {
            console.log('Error! ', error);
        });
        return; 
        }

        //get cached etags
        var cachedetags = JSON.parse(localStorage.getItem('etgas'));         
        var isReloadAPIData = false;

        await fetch(apiUrl, {cache: 'no-store'})
        .then(response => {
        // extract etags from headers
        var etagsdata = response.headers.get('etag');

        if (!etagsdata) {
            isReloadAPIData = true;
        }
        // compare cached etags with the API etags
        if (etagsdata) {
            localStorage.setItem('etgas', JSON.stringify(etagsdata));
            if(etagsdata != cachedetags) {
            isReloadAPIData = true;
            } else {
            isReloadAPIData = false;
            }
        }
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
        }) 
        .then(parsed => {        
        data = parsed;
        if (!data) {
            throw Error('Empty JSON data');
        }
        
        if (!data.generalRecommendations || !data.specificRecommendations) {
            throw Error('Missing recommendation data');
        }

        if (isReloadAPIData) {
            // if API is newer version
            const genRecArr = data && data.generalRecommendations;
            data && data.specificRecommendations && data.specificRecommendations.forEach(recommendation => {
                recommendation.generalRecommendation = genRecArr[recommendation.general];
                // recommendation.title = addTextStyle(recommendation.title);
                recommendation.tools = [];
                recommendation.tool && recommendation.tool.forEach(id => {
                if (data.tools && data.tools[id]) recommendation.tools.push(data.tools[id]);
                });
            });
            data.recGroupedByGrade = groupBy( data.specificRecommendations, 'grade');
            searchData.set(data);
            lastUpdated.set({'lastUpdated':data.lastUpdated, 'lastUpdatedText':data.lastUpdatedText});
            }
        
        return data;
        }
        ) 
        .catch(error => {
        console.log('Looks like there was a problem: \n', error);
        });
    }
  
    function reportWindowSize() {
        browserWidth = window.innerWidth;
        if (browserWidth <850) {
            isMobile = true;
        } else {
            isMobile = false;
        }
        bIsMobileStore.set(isMobile);
    }

    window.onresize = reportWindowSize;

    const unsubscribe = oFilterStore.subscribe(obj => {
        filterFieldObj = obj;
        handleSearchQuery();
	});

    onDestroy(unsubscribe);

    function fCollapseSidebarMobile() {
        isCollapseMobile = !isCollapseMobile;
    }

    function refreshapi() {
        getSearchData()
    }
    
    function handleSaveSearch () {
        const sName = inputSearchName.toLowerCase().trim();
        // Put the filter object into storage
        localStorage.setItem('wv-filter-' + sName, JSON.stringify(filterFieldObj));

        // Add new key to stored filter keys, which will add the new tag to the page
        const arr = $arrSavedFilterKeys;
        arr.push(sName);
        arrSavedFilterKeys.set(arr);
    }

    function handleInput (key) {
        if (key=='keywords' && inputKeywords !== searchedKeywords) {
            searchedKeywords = inputKeywords;
            filterFieldObj.keywords.values = [inputKeywords];
        } else if (key === 'age') {
            const ageVal = inputAge;
            filterFieldObj.age.values = [ageVal];
        } else if (key === 'weight') {
            filterFieldObj.weightMetric.values = [fConvertLBToKG(inputWeight)];
            filterFieldObj.weight.values = [inputWeight];
        } else if (key === 'weightMetric') {
            filterFieldObj.weightMetric.values = [inputWeightMetric];
            filterFieldObj.weight.values = [fConvertKGToLB(inputWeightMetric)];
        } else if (key === 'height') {
            let heightVal = (inputHeightFt || inputHeightIn) ? fConvertToInches(inputHeightFt, inputHeightIn) : null;
            filterFieldObj.height.values = [heightVal];
            filterFieldObj.heightFt.values = [inputHeightFt];
            filterFieldObj.heightIn.values = [inputHeightIn];
            filterFieldObj.heightMetric.values = [fConvertInchesToCM(heightVal)];
        } else if (key === 'heightMetric') {
            const heightInInches = fConvertCMToInches(inputHeightCm);
            const arrHeightFtInVal = fConvertToFtIn(heightInInches);

            filterFieldObj.height.values = [heightInInches];
            filterFieldObj.heightMetric.values = [inputHeightCm];
            
            filterFieldObj.heightFt.values = [arrHeightFtInVal && arrHeightFtInVal[0] || null];
            filterFieldObj.heightIn.values = [arrHeightFtInVal && arrHeightFtInVal[1] || null];
        } else {
            return;
        }
        bIsFilterStore.set(true);
        oFilterStore.set(filterFieldObj);
    }

    function handleFilterBtnClick(key, val, isActive) {

        // Disable pregnant buttons when sex is not female
        if (key === 'sex') {
            if (val === 'Female' && isActive === false) {
                isFemale = true;
            } else {
                // clear pregnant data
                handleDeselectBtn('pregnant');
                isFemale = false;
            }
        }

        // deselect
        if (isActive) {
            handleDeselectBtn(key);
            return;
        }

        // select
        filterFieldObj[key].options.forEach(opt => {
            if (opt.value === val) {
                opt.isActive = true;
            } else {
                opt.isActive = false;
            }
        });
        filterFieldObj[key].values = [val];
        bIsFilterStore.set(true);
        oFilterStore.set(filterFieldObj);
    };

    function handleDeselectBtn(key) {
        filterFieldObj[key].options.forEach(opt => {
            opt.isActive = false;
        });
        filterFieldObj[key].values = [];
        oFilterStore.set(filterFieldObj);
    }

    function handleChangeUnit() {
        isMetric = !isMetric;
        // handleReset();
        document.cookie=`ismetric=${isMetric}`;
    }

    function fResetChange(isReset) {
        if (isReset) {
            handleReset();
        }
    }

    function handleReset() {
        getSearchData();
        fResetFilter(filterFieldObj);
        inputKeywords = null;
        inputAge = null;
        inputWeight = null;
        inputWeightMetric = null; 
        inputHeightCm = null;
        inputHeightFt = null;
        inputHeightIn = null;
        bIsFilterStore.set(false);
        oFilterStore.set(FILTERDEFAULT);
        isFemale = false;
        inputSearchName = null;
    }

    function handleSearchQuery() {
        Object.keys(filterFieldObj).forEach(key => {
            if (!filterFieldObj[key] || !filterFieldObj[key].values) { return; }
            const value = filterFieldObj[key].values[0];
            if (key === 'age') {
                inputAge = value || "";
            } else if (key === 'keywords') {
                inputKeywords = value || "";
            } else if (key==='weight') {
                inputWeight = value || "";
            } else if (key === "weightMetric") {
                inputWeightMetric = value || "";
            } else if (key === 'sex') {
                // if female
                if(value === 'Female') {
                    isFemale = true;
                } else if (value === 'Male') {
                    isFemale = false;
                }
            }

            // if height values exist, update height values in English unit as well 
            if (filterFieldObj['height'].values || filterFieldObj['heightFt'].values || filterFieldObj['heightIn'].values || filterFieldObj['heightMetric'].values) {
                if (key === 'heightMetric') {
                    inputHeightCm = value;
                } else if (key==='heightFt') {
                    inputHeightFt = value;
                } else if (key==='heightIn') {
                    inputHeightIn = value;
                }
            } else {
                inputHeightCm = "";
                inputHeightFt = "";
                inputHeightIn = "";
            }
        });
    }

</script>
<style>
/* bug : long text in content */
p {
    overflow: auto;
}

:global(.block.block-strong) {
    padding-bottom: 0px;
}

.button:not(.button-active) {
    background-color: #fff;
}

.text-white {
    color: #ffffff !important;
}

::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #a1caf1;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #a1caf1;
   opacity:  1;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #909;
   opacity:  1;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #a1caf1;
}
::-ms-input-placeholder { /* Microsoft Edge */
   color:    #a1caf1;
}

::placeholder { /* Most modern browsers support this now. */
   color:    #a1caf1;
}

@media only screen and (min-width: 850px) {

}
</style>